import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../../global.service';
import { EventsService } from '../../../events.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-rainbow-six-siege',
  templateUrl: './rainbow-six-siege.component.html',
  styleUrls: ['./rainbow-six-siege.component.css']
})
export class RainbowSixSeigeComponent implements OnInit {

  gameName = "rainbow-six-siege";

  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {
  }

  ngOnInit() {
    
  }

  

}
